<script>
import LegoControlCardAssignments from "@/components/Lego/LegoControlCardAssignments.vue";
import LegoControlCardDate from "@/components/Lego/LegoControlCardDate.vue";
import LegoControlCardDone from "@/components/Lego/LegoControlCardDone.vue";
import LegoControlCardEffort from "@/components/Lego/LegoControlCardEffort.vue";
import LegoControlCardAuditoria from "@/components/Lego/LegoControlCardAuditoria.vue";
import LegoControlCardAuditoriaCalificacion from "@/components/Lego/LegoControlCardAuditoriaCalificacion.vue";
import LegoControlCardValidate from "@/components/Lego/LegoControlCardValidate.vue";
import LegoControlCardAdjuntos from "@/components/Lego/LegoControlCardAdjuntos.vue";
import LegoControlCardChat from "@/components/Lego/LegoControlCardChat.vue";

export default {
  components: {
    LegoControlCardAssignments,
    LegoControlCardDate,
    LegoControlCardDone,
    LegoControlCardEffort,
    LegoControlCardAuditoria,
    LegoControlCardAuditoriaCalificacion,
    LegoControlCardValidate,
    LegoControlCardAdjuntos,
    LegoControlCardChat,
  },
  data() {
    return {
      waitGetDone: false,
    };
  },
  computed: {
    collaborators() {
      return this.$store.state.lego.board.collaborators;
    },
    isShowBtnChat() {
      const assignmentsIds = this.card.assignments?.map((a) => a.personaId);
      // console.log("assignmentsIds", assignmentsIds);

      const personaAct = JSON.parse(localStorage.getItem("setPersonaAct"));
      // console.log("personaAct", personaAct.id);

      return assignmentsIds?.includes(personaAct.id);
    },
    card() {
      return this.$store.state.lego.card;
    },
    roleLevel() {
      return this.$store.state.lego.currencyRole.level;
    },
  },
};
</script>

<template>
  <div class="header__controls">
    <!-- Problema grande de reactividad, hay que crear una accion para cada uno de ellos -->
    <LegoControlCardDone :card="card" id="TableroFinalizado" />
    <LegoControlCardValidate
      :card="card"
      v-if="roleLevel <= 2"
      id="TableroValidar"
    />
    <!-- id="TableroConformidad" -->
    <LegoControlCardAuditoria
      :card="card"
      v-if="roleLevel <= 2"
      id="TableroAuditoria"
    />
    <LegoControlCardAuditoriaCalificacion
      :card="card"
      v-if="roleLevel <= 2"
      id="TableroAuditoriaCalificacion"
    />
    <LegoControlCardDate :card="card" id="TableroFecha" />
    <LegoControlCardEffort :card="card" id="TableroEsfuerzo" />
    <LegoControlCardAdjuntos :card="card" id="TableroAdjuntos" />
    <LegoControlCardChat :card="card" id="TableroChat" v-if="isShowBtnChat" />
    <LegoControlCardAssignments
      :collaborators="collaborators"
      :card="card"
      id="TableroColaboradores"
    />
  </div>
</template>

<style scoped>
.header__controls {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  /* border: 1px solid red; */
}
</style>
